import FormField from '../../components/field/FormField';
import { AccessLevel } from '../../enums/AccessLevel';
import { CompanyTeamMemberPermission } from '../../types/Team';
import { BaseSyntheticEvent, useEffect, useState } from 'react';
import { apiUrl } from '../../api/apiUrl';
import http from '../../api/axios';
import { handleApiErrors } from '../../api/apiErrorHandler';
import { convertEnumToArray, ObjectFromEnum } from '../../utils/functions/data.functions';
import { toast } from 'react-toastify';
import { useLoading } from '../../context/loadingContext';

interface Props {
  companyTeamMemberId?: number;
}
/**
 * Form component to for remove / create permissions for teams in currend company
 */
export const PermissionForm = ({ companyTeamMemberId }: Props) => {
  const { startLoading, stopLoading } = useLoading();
  const [permissions, setPermissions] = useState<CompanyTeamMemberPermission[] | null>(null);
  /**
   * Loads user companies
   */
  const fetchPermissions = async () => {
    const response = await http.apiGet({
      url: `${apiUrl.COMPANY_TEAM_MEMBER_PERMISSION_LIST}?parentId=${companyTeamMemberId}`,
    });
    setPermissions(response?.data);
  };

  useEffect(() => {
    fetchPermissions();
  }, []);

  /**
   * Creates permission for team to company
   * @param accessLevel - Read | Write | Admin
   */
  const handleCreatePermission = async (accessLevel: string) => {
    try {
      startLoading();
      const response = await http.apiPost({
        url: apiUrl.COMPANY_TEAM_MEMBER_PERMISSION_CREATE,
        data: { companyTeamMemberId: companyTeamMemberId, accessLevel: accessLevel },
      });
      if (response?.status === 201) {
        stopLoading();
        toast.success('Success!');
        fetchPermissions();
      }
    } catch (err) {
      stopLoading();
      handleApiErrors(err);
    }
  };

  /**
   * Removes permission for team to company
   * @param accessLevel - Read | Write | Admin
   */
  const handleRemovePremission = async (accessLevel: string) => {
    try {
      const permissionId = permissions?.find(
        (p: CompanyTeamMemberPermission) => p.accessLevel === accessLevel,
      )?.id;
      if (permissionId) {
        const response = await http.apiDelete({
          url: `${apiUrl.COMPANY_TEAM_MEMBER_PERMISSION_DELETE}?id=${permissionId}`,
        });
        if (response?.status === 204) {
          toast.success('Success!');
          fetchPermissions();
        }
      }
    } catch (err) {
      handleApiErrors(err);
    }
  };

  /**
   * Handles checkbox event for permission - create or remove
   * @param e - checkbox input event
   */
  const handleOnChange = async (e: BaseSyntheticEvent) => {
    if (!e || !e.target) return;
    if (e.target.checked) {
      handleCreatePermission(e.target.id);
    } else {
      handleRemovePremission(e.target.id);
    }
  };

  return (
    <>
      {convertEnumToArray(AccessLevel).map((i: ObjectFromEnum) => (
        <div key={i.value} className="inline-block text-center px-3 items-center m-auto">
          <label htmlFor={i.value} className="m">
            {i.value}
          </label>
          <FormField
            key={i.value}
            name={i.value}
            id={i.value}
            type="checkbox"
            onChange={handleOnChange}
            checked={
              !!(
                permissions &&
                permissions.filter((p: CompanyTeamMemberPermission) => p.accessLevel === i.value)
                  .length > 0
              )
            }
            className={`w-4 h-4`}
          />
        </div>
      ))}
    </>
  );
};
